import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SectionHead, FadeUp } from "@/components/Reveal";
import Accordion from "@/components/Accordion";
import { FAQS } from "@/lib/content";

export default function FAQSection() {
  return (
    <section className="relative py-24 sm:py-32 border-t border-white/5" data-testid="faq-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <div className="lg:sticky lg:top-32">
            <SectionHead eyebrow="FAQ" title="Frequently asked questions" />
            <FadeUp delay={0.2}>
              <Link
                to="/faq"
                data-testid="faq-view-all-link"
                className="mt-8 inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-neon hover:text-neonhover transition-colors"
              >
                All questions
                <ArrowRight size={14} />
              </Link>
            </FadeUp>
          </div>
        </div>
        <div className="lg:col-span-8">
          <FadeUp delay={0.1}>
            <Accordion items={FAQS.slice(0, 5)} testidBase="home-faq" />
          </FadeUp>
        </div>
      </div>
    </section>
  );
}
